import {useState, useEffect, useContext} from "react";
import "./MainBlog.scss";
import CommentSection from "../CommentSection/CommentSection";
import {useParams, useNavigate} from "react-router-dom";
import CardBlog from "./CardBlog";
import Title from "../Title/Title";
import axios from "axios";
import {prefixUrl} from "../../Utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../Loader/Loader";
import {SetSaleContext} from "../pages/Pages";
import CustomMetaTags from "../SeoManage/CustomMetaTags ";

const DetailBlog = () => {

  const [detailBlog, setDetailBlog] = useState({});
  const blogId = useParams();
  const Navigate = useNavigate();
  const [isLoad, setIsLoad] = useState(false);
  const [setValue] = CustomMetaTags({})

  useEffect(() => {
    setIsLoad(false)
    const currentlogId = blogId?.id.match(/\d+/)[0];
    const backendEndpoint = `${prefixUrl()}/blog/detail.php?blogId=${currentlogId}`;

    axios.get(backendEndpoint).then((response) => {
      if (response.data.status) {
        const backDetailBlog = response.data.output;
        setDetailBlog(backDetailBlog);
        setIsLoad(true);
        if (!Array.isArray(backDetailBlog?.seo)) {
          setValue(backDetailBlog?.seo)
        }
      } else {
        toast.error("خطا در بر قراری ارتباط");
      }
    });
  }, [blogId]);

  let blogText = detailBlog?.text && detailBlog?.text.replace(/\n/g, "<br>");

  const setNumContext = useContext(SetSaleContext);
  const handleAddToCart = (productInfo) => {
    let pros =
      localStorage.getItem("products") !== ""
        ? JSON.parse(localStorage.getItem("products"))
        : [];

    if (productInfo.type === 2) {
      productInfo.count = +productInfo.defultValue * productInfo.count
    }

    if (pros.length === 0) {
      pros.push(productInfo);
    } else {
      const index = pros.findIndex((item) => item.id === productInfo.id);

      if (index !== -1) {
        pros[index].count = +pros[index].count + +productInfo.count;
      } else {
        pros.push(productInfo);
      }
    }
    localStorage.setItem("products", JSON.stringify(pros));
    setNumContext((prevNum) => prevNum + 1);
  };

  const bannerClickHandler = () => {
    axios
      .post(`${prefixUrl()}/cart/sample.php`, {blogId: detailBlog?.id})
      .then((response) => {
        if (response.data.status) {
          toast.success("سبد خرید این غذا اضافه شد");
          for (let item of response.data.output) {
            handleAddToCart(item);
          }
        } else {
          toast.error(response.data.output);
        }
      });
  };

  return (
    <div className="parent-main-blog-page" style={{marginBottom: 80}}>
      {isLoad ? (
        <div className="main-blog-page">
          <div className="detail-blog">
            <div className="right-side">
              <Title title={"بلاگ"} englishTitle={"Blog"}/>
              <div className="top-part">
                <div className="bigBlogPic__">
                  <img src={detailBlog.image} alt=""/>
                </div>
                <div className="add-to-basket">
                  <h4>{detailBlog.title}</h4>

                  {detailBlog.sampleCart && (
                    <button onClick={bannerClickHandler}>
                      افزودن به سبد خرید
                    </button>
                  )}
                </div>

                <div className="data-line">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="clock 1">
                      <path
                        id="Vector"
                        d="M9.99935 18.9584C5.05768 18.9584 1.04102 14.9417 1.04102 10C1.04102 5.05835 5.05768 1.04169 9.99935 1.04169C14.941 1.04169 18.9577 5.05835 18.9577 10C18.9577 14.9417 14.941 18.9584 9.99935 18.9584ZM9.99935 2.29169C5.74935 2.29169 2.29102 5.75002 2.29102 10C2.29102 14.25 5.74935 17.7084 9.99935 17.7084C14.2493 17.7084 17.7077 14.25 17.7077 10C17.7077 5.75002 14.2493 2.29169 9.99935 2.29169Z"
                        fill="#484848"
                      />
                      <path
                        id="Vector_2"
                        d="M13.0909 13.275C12.9826 13.275 12.8742 13.25 12.7742 13.1834L10.1909 11.6417C9.54922 11.2584 9.07422 10.4167 9.07422 9.67502V6.25836C9.07422 5.9167 9.35755 5.63336 9.69922 5.63336C10.0409 5.63336 10.3242 5.9167 10.3242 6.25836V9.67502C10.3242 9.97502 10.5742 10.4167 10.8326 10.5667L13.4159 12.1084C13.7159 12.2834 13.8076 12.6667 13.6326 12.9667C13.5076 13.1667 13.2992 13.275 13.0909 13.275Z"
                        fill="#484848"
                      />
                    </g>
                  </svg>
                  <p>{detailBlog.date}</p>
                </div>

                <div className={"from-text-editor"} dangerouslySetInnerHTML={{__html: blogText}}/>
                <div className="tag-row">
                  {/* <Link to></Link> */}
                  {detailBlog?.labels?.map((item) => (
                    <div
                      className="blog-tag"
                      onClick={() => Navigate(`/Blog/tag/${item.titleEN}`)}
                    >
                      {item.titleFA}
                    </div>
                  ))}
                </div>
              </div>

              <CommentSection
                detailBlog={detailBlog}
                blogId={blogId}
                type={1}
              />
            </div>

            <div className="left-side">
              <p className="on-top-blog">آخرین مطالب</p>
              {detailBlog?.latestPosts?.map((post, index) => (
                <CardBlog blogData={post} key={index}/>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <Loader/>
      )}
    </div>
  );
};
export default DetailBlog;
